var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_14867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 0.267334C7.24316 0.267334 3.13241 3.03601 1.19141 7.04996H22.8099C20.869 3.03601 16.7582 0.267334 12.0007 0.267334Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24.2687C16.7582 24.2687 20.869 21.5 22.81 17.4861H1.19141C3.13241 21.5 7.24316 24.2687 12.0007 24.2687Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5873 12.2691L14.1218 12.9585L14.9022 14.3778L13.3108 14.0733L13.1092 15.681L12.0007 14.4986L10.8922 15.681L10.6906 14.0733L9.09919 14.3777L9.87956 12.9584L8.41406 12.2691L9.87961 11.5797L9.09919 10.1604L10.6905 10.4648L10.8923 8.85718L12.0007 10.0396L13.1092 8.85718L13.3108 10.4648L14.9023 10.1604L14.1218 11.5797L15.5873 12.2691Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_14867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ARS.75aba1447b5270f3f26c1db76803b41b.svg";